import React from 'react';
import {emojify} from 'react-emojione';
import Moment from 'react-moment';

const Message = ({ msg }) => (
    <div class="bubble">
        <div class="talk-bubble-info">            
            <Moment fromNow>{msg.time}</Moment>
            <p>{msg.author.name} says:</p>
        </div>
        <div class="talk-bubble">
        <p>{emojify(msg.emotion)}</p>
        <p>{msg.text}</p>
        </div>
    </div>
);

const MessageList = ({ messages }) => {
    const listItems = messages.map((message, index) => 
        <li key={index}><Message msg={message}/></li>
    );
    return (
        <ul>{listItems}</ul>
    );

}

export default MessageList;


// WEBPACK FOOTER //
// ./src/components/MessageList.js